import type { Work } from "@/mocks/works";
import WorkCard from "@/components/feature/WorkCard";

interface RelatedWorksProps {
  works: Work[];
}

export default function RelatedWorks({ works }: RelatedWorksProps) {
  if (works.length === 0) return null;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
      {works.map((work) => (
        <WorkCard key={work.id} work={work} />
      ))}
    </div>
  );
}